// Import Module 6 instances
import { MODULE_6_INSTANCES } from './module6Instances';

// Module 1: Reading emotional states (theory of mind) - FROM MD DOCUMENT
export const MODULE_1_INSTANCES = {
  // Module 1A: Reading emotional states - All 9 instances from markdown document
  '1A': {
    guests: [
      { name: "Trish", image: 2, emotions: ["Unimpressed", "Compassionate", "Delighted"], correct: "Unimpressed" },
      { name: "Pamela", image: 8, emotions: ["Joyful", "Composed", "Serious"], correct: "Joyful" },
      { name: "Peter", image: 5, emotions: ["Determined", "Disappointed", "Welcoming"], correct: "Determined" },
      { name: "Karl", image: 5, emotions: ["Pleased", "Surprised", "Worried"], correct: "Pleased" },
      { name: "Samantha", image: 2, emotions: ["Concerned", "Disengaged", "Content"], correct: "Concerned" },
      { name: "Manuel", image: 3, emotions: ["Preoccupied", "Bright-eyed", "Dejected"], correct: "Preoccupied" },
      { name: "Reina", image: 7, emotions: ["Confident", "Unsmiling", "In awe"], correct: "Confident" },
      { name: "Joey", image: 1, emotions: ["Glaring", "Engaged", "Mesmerized"], correct: "Glaring" },
      { name: "Roy", image: 7, emotions: ["Curious", "Mistrustful", "Confused"], correct: "Curious" }
    ]
  },
  // Module 1B: Food preferences - Based on markdown document structure
  // Each guest has 3 dishes shown with different facial expressions
  // The number indicates the image file to use (e.g., "Trish 1", "Trish 4", "Trish 8")
  '1B': {
    guests: [
      { 
        name: "Trish",
        dishes: [
          { food: "Pasta", image: 1, rank: 1 },  // least favorite
          { food: "Lamb", image: 4, rank: 2 },   // second favorite  
          { food: "Chicken", image: 8, rank: 3 } // favorite
        ]
      },
      {
        name: "Pamela", 
        dishes: [
          { food: "Chicken", image: 1, rank: 1 },
          { food: "Steak", image: 4, rank: 2 },
          { food: "Shrimp", image: 8, rank: 3 }
        ]
      },
      {
        name: "Peter",
        dishes: [
          { food: "Vegetarian", image: 1, rank: 1 },
          { food: "Shrimp", image: 5, rank: 2 },
          { food: "Fish", image: 8, rank: 3 }
        ]
      },
      {
        name: "Karl",
        dishes: [
          { food: "Steak", image: 2, rank: 1 },
          { food: "Vegetarian", image: 5, rank: 2 },
          { food: "Lamb", image: 8, rank: 3 }
        ]
      },
      {
        name: "Samantha",
        dishes: [
          { food: "Pasta", image: 1, rank: 1 },
          { food: "Vegetarian", image: 5, rank: 2 },
          { food: "Steak", image: 8, rank: 3 }
        ]
      },
      {
        name: "Manuel",
        dishes: [
          { food: "Chicken", image: 1, rank: 1 },
          { food: "Pasta", image: 7, rank: 2 },
          { food: "Lamb", image: 8, rank: 3 }
        ]
      },
      {
        name: "Reina",
        dishes: [
          { food: "Vegetarian", image: 1, rank: 1 },
          { food: "Steak", image: 5, rank: 2 },
          { food: "Fish", image: 7, rank: 3 }
        ]
      },
      {
        name: "Joey",
        dishes: [
          { food: "Pasta", image: 1, rank: 1 },
          { food: "Lamb", image: 6, rank: 2 },
          { food: "Steak", image: 7, rank: 3 }
        ]
      },
      {
        name: "Roy",
        dishes: [
          { food: "Fish", image: 1, rank: 1 },
          { food: "Steak", image: 5, rank: 2 },
          { food: "Chicken", image: 7, rank: 3 }
        ]
      }
    ]
  }
};

// Module 2: Seating arrangement preferences (abstract reasoning) - FROM NEW JSON FILES
export const MODULE_2_INSTANCES = {
  1: {
    difficulty: 1.0,
    title: "Beginner",
    explanation: "Both triangles are broken cleanly, leaving two light chains that interleave without detest clashes.",
    guests: {
      Manuel: { preferred: "Fish", second: "Chicken", detests: "Lamb" },
      Pamela: { preferred: "Steak", second: "Chicken", detests: "Vegetarian" },
      Trish: { preferred: "Chicken", second: "Steak", detests: "Pasta" },
      Karl: { preferred: "Vegetarian", second: "Pasta", detests: "Fish" },
      Joey: { preferred: "Pasta", second: "Fish", detests: "Steak" },
      Reina: { preferred: "Lamb", second: "Vegetarian", detests: "Chicken" }
    }
  },
  2: {
    difficulty: 2.0,
    title: "Beginner",
    explanation: "Slightly more overlap than #1; resolves with a couple of early deductions.",
    guests: {
      Manuel: { preferred: "Fish", second: "Chicken", detests: "Steak" },
      Pamela: { preferred: "Steak", second: "Chicken", detests: "Fish" },
      Trish: { preferred: "Chicken", second: "Fish", detests: "Lamb" },
      Karl: { preferred: "Vegetarian", second: "Fish", detests: "Chicken" },
      Joey: { preferred: "Pasta", second: "Steak", detests: "Vegetarian" },
      Reina: { preferred: "Lamb", second: "Pasta", detests: "Fish" }
    }
  },
  3: {
    difficulty: 4.0,
    title: "Intermediate",
    explanation: "Cross-pressures between Manuel–Pamela–Trish and the Karl–Reina side require considering both halves together.",
    guests: {
      Manuel: { preferred: "Fish", second: "Steak", detests: "Lamb" },
      Pamela: { preferred: "Steak", second: "Fish", detests: "Vegetarian" },
      Trish: { preferred: "Chicken", second: "Steak", detests: "Pasta" },
      Karl: { preferred: "Vegetarian", second: "Chicken", detests: "Fish" },
      Joey: { preferred: "Pasta", second: "Lamb", detests: "Steak" },
      Reina: { preferred: "Lamb", second: "Vegetarian", detests: "Chicken" }
    }
  },
  4: {
    difficulty: 5.0,
    title: "Intermediate",
    explanation: "Detests narrow which block can sit next to which; multiple entry points remain for deduction.",
    guests: {
      Manuel: { preferred: "Fish", second: "Lamb", detests: "Steak" },
      Pamela: { preferred: "Steak", second: "Chicken", detests: "Fish" },
      Trish: { preferred: "Chicken", second: "Vegetarian", detests: "Lamb" },
      Karl: { preferred: "Vegetarian", second: "Fish", detests: "Steak" },
      Joey: { preferred: "Pasta", second: "Steak", detests: "Vegetarian" },
      Reina: { preferred: "Lamb", second: "Pasta", detests: "Steak" }
    }
  },
  5: {
    difficulty: 6.0,
    title: "Intermediate",
    explanation: "Less obvious pairing structure; solvers often need to try/eliminate one arrangement.",
    guests: {
      Manuel: { preferred: "Fish", second: "Chicken", detests: "Lamb" },
      Pamela: { preferred: "Steak", second: "Fish", detests: "Vegetarian" },
      Trish: { preferred: "Chicken", second: "Fish", detests: "Pasta" },
      Karl: { preferred: "Vegetarian", second: "Pasta", detests: "Fish" },
      Joey: { preferred: "Pasta", second: "Lamb", detests: "Steak" },
      Reina: { preferred: "Lamb", second: "Steak", detests: "Chicken" }
    }
  },
  6: {
    difficulty: 7.0,
    title: "Advanced",
    explanation: "Several second-favorite targets cross groups; juggle pairs without tripping detests.",
    guests: {
      Manuel: { preferred: "Fish", second: "Vegetarian", detests: "Steak" },
      Pamela: { preferred: "Steak", second: "Chicken", detests: "Pasta" },
      Trish: { preferred: "Chicken", second: "Vegetarian", detests: "Lamb" },
      Karl: { preferred: "Vegetarian", second: "Fish", detests: "Steak" },
      Joey: { preferred: "Pasta", second: "Fish", detests: "Vegetarian" },
      Reina: { preferred: "Lamb", second: "Pasta", detests: "Fish" }
    }
  },
  7: {
    difficulty: 8.0,
    title: "Advanced",
    explanation: "Forcing M→Pasta and K→Lamb constrains two junctions; most impulsive placements dead-end.",
    guests: {
      Manuel: { preferred: "Fish", second: "Pasta", detests: "Lamb" },
      Pamela: { preferred: "Steak", second: "Fish", detests: "Vegetarian" },
      Trish: { preferred: "Chicken", second: "Steak", detests: "Pasta" },
      Karl: { preferred: "Vegetarian", second: "Lamb", detests: "Fish" },
      Joey: { preferred: "Pasta", second: "Lamb", detests: "Steak" },
      Reina: { preferred: "Lamb", second: "Vegetarian", detests: "Chicken" }
    }
  },
  8: {
    difficulty: 9.0,
    title: "Expert",
    explanation: "Edits couple three edges so that only a narrow interleaving works once detests are honored.",
    guests: {
      Manuel: { preferred: "Fish", second: "Pasta", detests: "Steak" },
      Pamela: { preferred: "Steak", second: "Chicken", detests: "Pasta" },
      Trish: { preferred: "Chicken", second: "Vegetarian", detests: "Lamb" },
      Karl: { preferred: "Vegetarian", second: "Fish", detests: "Lamb" },
      Joey: { preferred: "Pasta", second: "Lamb", detests: "Vegetarian" },
      Reina: { preferred: "Lamb", second: "Pasta", detests: "Fish" }
    }
  },
  9: {
    difficulty: 9.5,
    title: "Expert",
    explanation: "The second-favorite graph looks friendly, but only a tight interleaving works.",
    guests: {
      Manuel: { preferred: "Fish", second: "Chicken", detests: "Lamb" },
      Pamela: { preferred: "Steak", second: "Fish", detests: "Vegetarian" },
      Trish: { preferred: "Chicken", second: "Vegetarian", detests: "Pasta" },
      Karl: { preferred: "Vegetarian", second: "Pasta", detests: "Fish" },
      Joey: { preferred: "Pasta", second: "Lamb", detests: "Steak" },
      Reina: { preferred: "Lamb", second: "Pasta", detests: "Chicken" }
    }
  },
  10: {
    difficulty: 10.0,
    title: "Master",
    explanation: "Remaining degrees of freedom collapse; most partial seatings break a detest late in the chain.",
    guests: {
      Manuel: { preferred: "Fish", second: "Chicken", detests: "Steak" },
      Pamela: { preferred: "Steak", second: "Chicken", detests: "Vegetarian" },
      Trish: { preferred: "Chicken", second: "Steak", detests: "Lamb" },
      Karl: { preferred: "Vegetarian", second: "Fish", detests: "Chicken" },
      Joey: { preferred: "Pasta", second: "Steak", detests: "Vegetarian" },
      Reina: { preferred: "Lamb", second: "Pasta", detests: "Fish" }
    }
  }
};

// Module 2 Solutions - FROM NEW JSON FILES
export const MODULE_2_SOLUTIONS = {
  1: [
    ["Manuel", "Trish", "Pamela", "Reina", "Karl", "Joey"],
    ["Manuel", "Joey", "Karl", "Reina", "Pamela", "Trish"]
  ],
  2: [
    ["Manuel", "Trish", "Pamela", "Joey", "Reina", "Karl"],
    ["Manuel", "Karl", "Reina", "Joey", "Pamela", "Trish"]
  ],
  3: [
    ["Manuel", "Pamela", "Trish", "Karl", "Reina", "Joey"],
    ["Manuel", "Joey", "Reina", "Karl", "Trish", "Pamela"]
  ],
  4: [
    ["Manuel", "Karl", "Trish", "Pamela", "Joey", "Reina"],
    ["Manuel", "Reina", "Joey", "Pamela", "Trish", "Karl"]
  ],
  5: [
    ["Manuel", "Pamela", "Reina", "Joey", "Karl", "Trish"],
    ["Manuel", "Trish", "Karl", "Joey", "Reina", "Pamela"]
  ],
  6: [
    ["Manuel", "Karl", "Trish", "Pamela", "Reina", "Joey"],
    ["Manuel", "Joey", "Reina", "Pamela", "Trish", "Karl"]
  ],
  7: [
    ["Manuel", "Pamela", "Trish", "Karl", "Reina", "Joey"],
    ["Manuel", "Joey", "Reina", "Karl", "Trish", "Pamela"]
  ],
  8: [
    ["Manuel", "Karl", "Trish", "Pamela", "Reina", "Joey"],
    ["Manuel", "Joey", "Reina", "Pamela", "Trish", "Karl"]
  ],
  9: [
    ["Manuel", "Pamela", "Reina", "Joey", "Karl", "Trish"],
    ["Manuel", "Trish", "Karl", "Joey", "Reina", "Pamela"]
  ],
  10: [
    ["Manuel", "Trish", "Pamela", "Joey", "Reina", "Karl"],
    ["Manuel", "Karl", "Reina", "Joey", "Pamela", "Trish"]
  ]
};

// Module 3: Entering guests orders (proprioceptive memory) - FROM MD DOCUMENT
export const MODULE_3_INSTANCES = {
  mealToButtonMapping: {
    "Steak": [1, 2, 3],
    "Salmon": [2, 3, 4], 
    "Shrimp": [3, 4, 1],
    "Salad": [4, 1, 2],
    "Chicken": [1, 3, 2],
    "Lamb": [2, 4, 3]
  },
  1: {
    difficulty: 1,
    title: "Single Meal Sequence",
    task: "Reproduce the button sequence for 1 meal after the sequence is played.",
    mealOrder: ["Steak"],
    buttonSequence: [[1, 2, 3]],
    showSequence: true,
    requireMemory: false
  },
  2: {
    difficulty: 2, 
    title: "Two Meal Sequence",
    task: "Reproduce the button sequences for 2 meals in order after the sequence for each meal is played.",
    mealOrder: ["Steak", "Salmon"],
    buttonSequence: [[1, 2, 3], [2, 3, 4]],
    showSequence: true,
    requireMemory: false
  },
  3: {
    difficulty: 3,
    title: "Three Meal Memory",
    task: "Reproduce the button sequences for 3 meals in order after the sequence for each meal is played.",
    mealOrder: ["Steak", "Salmon", "Shrimp"],
    buttonSequence: [[1, 2, 3], [2, 3, 4], [3, 4, 1]],
    showSequence: true,
    requireMemory: false
  },
  4: {
    difficulty: 4,
    title: "Four Meal Sequence",
    task: "Reproduce the button sequences for 4 meals in order after the sequence for each meal is played.",
    mealOrder: ["Steak", "Salmon", "Shrimp", "Salad"],
    buttonSequence: [[1, 2, 3], [2, 3, 4], [3, 4, 1], [4, 1, 2]],
    showSequence: true,
    requireMemory: false
  },
  5: {
    difficulty: 5,
    title: "Five Meal Sequence",
    task: "Reproduce the button sequences for 5 meals in order after the sequence for each meal is played.",
    mealOrder: ["Steak", "Salmon", "Shrimp", "Salad", "Chicken"],
    buttonSequence: [[1, 2, 3], [2, 3, 4], [3, 4, 1], [4, 1, 2], [1, 3, 2]],
    showSequence: true,
    requireMemory: false
  },
  6: {
    difficulty: 6,
    title: "Six Meal Sequence",
    task: "Reproduce the button sequences for 6 meals in order after the sequence for each meal is played.",
    mealOrder: ["Steak", "Salmon", "Shrimp", "Salad", "Chicken", "Lamb"],
    buttonSequence: [[1, 2, 3], [2, 3, 4], [3, 4, 1], [4, 1, 2], [1, 3, 2], [2, 4, 3]],
    showSequence: true,
    requireMemory: false
  },
  7: {
    difficulty: 7,
    title: "Observe Standard, Reproduce Different Order",
    task: "Observe the button sequence in the typical order. Reproduce the button sequences for 6 meals but in a different order.",
    mealOrder: ["Salmon", "Steak", "Lamb", "Shrimp", "Chicken", "Salad"],
    observedOrder: ["Steak", "Salmon", "Shrimp", "Salad", "Chicken", "Lamb"],
    buttonSequence: [[2, 3, 4], [1, 2, 3], [2, 4, 3], [3, 4, 1], [1, 3, 2], [4, 1, 2]],
    showSequence: true,
    requireMemory: false,
    showDifferentOrder: true
  },
  8: {
    difficulty: 8,
    title: "Observe Standard, Reproduce Challenging Order",
    task: "Observe the button sequence in the typical order. Reproduce the button sequences for 6 meals but in a different order.",
    mealOrder: ["Lamb", "Salad", "Salmon", "Steak", "Shrimp", "Chicken"],
    observedOrder: ["Steak", "Salmon", "Shrimp", "Salad", "Chicken", "Lamb"],
    buttonSequence: [[2, 4, 3], [4, 1, 2], [2, 3, 4], [1, 2, 3], [3, 4, 1], [1, 3, 2]],
    showSequence: true,
    requireMemory: false,
    showDifferentOrder: true
  },
  9: {
    difficulty: 9,
    title: "Pure Memory Different Order",
    task: "Reproduce the button sequences for 6 meals from memory in a different order.",
    mealOrder: ["Shrimp", "Chicken", "Lamb", "Steak", "Salad", "Salmon"],
    buttonSequence: [[3, 4, 1], [1, 3, 2], [2, 4, 3], [1, 2, 3], [4, 1, 2], [2, 3, 4]],
    showSequence: false,
    requireMemory: true
  },
  10: {
    difficulty: 10,
    title: "Most Challenging Memory Order",
    task: "Reproduce the button sequences for 6 meals, with the most challenging shuffled order.",
    mealOrder: ["Salad", "Lamb", "Steak", "Shrimp", "Salmon", "Chicken"],
    buttonSequence: [[4, 1, 2], [2, 4, 3], [1, 2, 3], [3, 4, 1], [2, 3, 4], [1, 3, 2]],
    showSequence: false,
    requireMemory: true
  }
};

// Module 4: Remembering guests appearances - FROM MD DOCUMENT
// This module tests visual memory and facial recognition
export const MODULE_4_INSTANCES = {
  // TODO: Add instances from Module 4 markdown document
};

// Module 5: Color-based cognitive test - FROM MD DOCUMENT  
export const MODULE_5_INSTANCES = {
  // TODO: Add instances from Module 5 markdown document
};


// Module 7: Spatial reasoning with table layouts - FROM MD DOCUMENT
export const MODULE_7_INSTANCES = {
  // TODO: Add instances from Module 7 markdown document
};

// Module 8: Working memory with phone numbers and names - FROM MD DOCUMENT
export const MODULE_8_INSTANCES = {
  // TODO: Add instances from Module 8 markdown document
};

// Helper function to get a specific instance by module and difficulty
export const getModuleInstance = (moduleId, targetDifficulty) => {
  console.log(`🔍 getModuleInstance called: moduleId=${moduleId}, targetDifficulty=${targetDifficulty}`);
  
  let instances;
  
  switch (moduleId) {
    case '1A':
      return MODULE_1_INSTANCES['1A'];
    case '1B':
      return MODULE_1_INSTANCES['1B'];
    case '2':
      instances = MODULE_2_INSTANCES;
      break;
    case '3':
      instances = MODULE_3_INSTANCES;
      break;
    case '6':
      instances = MODULE_6_INSTANCES;
      break;
    case '7':
      // Module 7 instances are defined inline since they're simple
      instances = {
        1: { id: "d1", difficulty: 1, title: "One Attribute: Temperature", pattern: "one-attribute", target_attribute: "temperature", shared_value: "hot", options: [{ index: 1, type: "coffee", temperature: "hot", size: "small", asset: "small_hot_coffee.png" }, { index: 2, type: "tea", temperature: "hot", size: "medium", asset: "medium_hot_tea.png" }, { index: 3, type: "cider", temperature: "hot", size: "large", asset: "large_hot_cider.png" }, { index: 4, type: "tea", temperature: "room", size: "medium", asset: "medium_room_tea.png" }], solution_index: 4, explanation: "Three drinks are served hot (options 1–3); option 4 is room temperature." },
        2: { id: "d2", difficulty: 2, title: "One Attribute: Size", pattern: "one-attribute", target_attribute: "size", shared_value: "medium", options: [{ index: 1, type: "coffee", temperature: "cold", size: "medium", asset: "medium_cold_coffee.png" }, { index: 2, type: "tea", temperature: "room", size: "medium", asset: "medium_room_tea.png" }, { index: 3, type: "cider", temperature: "hot", size: "medium", asset: "medium_hot_cider.png" }, { index: 4, type: "tea", temperature: "cold", size: "large", asset: "large_cold_tea.png" }], solution_index: 4, explanation: "All but option 4 are medium; option 4 is large." },
        3: { id: "d3", difficulty: 3, title: "One Attribute: Type", pattern: "one-attribute", target_attribute: "type", shared_value: "coffee", options: [{ index: 1, type: "coffee", temperature: "room", size: "small", asset: "small_room_coffee.png" }, { index: 2, type: "coffee", temperature: "hot", size: "large", asset: "large_hot_coffee.png" }, { index: 3, type: "coffee", temperature: "cold", size: "medium", asset: "medium_cold_coffee.png" }, { index: 4, type: "tea", temperature: "cold", size: "medium", asset: "medium_cold_tea.png" }], solution_index: 4, explanation: "Three drinks are coffee (options 1–3); option 4 is tea." },
        4: { id: "d4", difficulty: 4, title: "One Attribute: Temperature", pattern: "one-attribute", target_attribute: "temperature", shared_value: "room", options: [{ index: 1, type: "tea", temperature: "room", size: "small", asset: "small_room_tea.png" }, { index: 2, type: "cider", temperature: "room", size: "medium", asset: "medium_room_cider.png" }, { index: 3, type: "coffee", temperature: "room", size: "large", asset: "large_room_coffee.png" }, { index: 4, type: "cider", temperature: "cold", size: "medium", asset: "medium_cold_cider.png" }], solution_index: 4, explanation: "Three drinks are room temperature (options 1–3); option 4 is cold." },
        5: { id: "d5", difficulty: 5, title: "One Attribute: Size", pattern: "one-attribute", target_attribute: "size", shared_value: "small", options: [{ index: 1, type: "coffee", temperature: "hot", size: "small", asset: "small_hot_coffee.png" }, { index: 2, type: "tea", temperature: "cold", size: "small", asset: "small_cold_tea.png" }, { index: 3, type: "cider", temperature: "room", size: "small", asset: "small_room_cider.png" }, { index: 4, type: "tea", temperature: "hot", size: "medium", asset: "medium_hot_tea.png" }], solution_index: 4, explanation: "The table orders are all small; option 4 is medium." },
        6: { id: "d6", difficulty: 6, title: "Two Attributes: Type–Temperature Pairing", pattern: "two-attributes", constraints: { by_type: { coffee: { temperature: "hot" }, tea: { temperature: "cold" }, cider: { temperature: "room" } } }, options: [{ index: 1, type: "coffee", temperature: "hot", size: "small", asset: "small_hot_coffee.png" }, { index: 2, type: "tea", temperature: "cold", size: "medium", asset: "medium_cold_tea.png" }, { index: 3, type: "cider", temperature: "room", size: "large", asset: "large_room_cider.png" }, { index: 4, type: "tea", temperature: "hot", size: "medium", asset: "medium_hot_tea.png" }], solution_index: 4, explanation: "Options 1–3 follow the rule (coffee hot, tea cold, cider room temperature). Option 4 shows tea hot." },
        7: { id: "d7", difficulty: 7, title: "Two Attributes: Temperature–Size Pairing", pattern: "two-attributes", constraints: { by_temperature: { hot: { size: "small" }, cold: { size: "medium" }, room: { size: "large" } } }, options: [{ index: 1, type: "coffee", temperature: "hot", size: "small", asset: "small_hot_coffee.png" }, { index: 2, type: "tea", temperature: "cold", size: "medium", asset: "medium_cold_tea.png" }, { index: 3, type: "cider", temperature: "room", size: "large", asset: "large_room_cider.png" }, { index: 4, type: "cider", temperature: "hot", size: "large", asset: "large_hot_cider.png" }], solution_index: 4, explanation: "Options 1–3 obey the temperature–size pairing; option 4 is hot but large (hot should be small)." },
        8: { id: "d8", difficulty: 8, title: "Two Attributes: Type–Size Pairing", pattern: "two-attributes", constraints: { by_type: { coffee: { size: "small" }, tea: { size: "medium" }, cider: { size: "large" } } }, options: [{ index: 1, type: "coffee", temperature: "hot", size: "small", asset: "small_hot_coffee.png" }, { index: 2, type: "tea", temperature: "room", size: "medium", asset: "medium_room_tea.png" }, { index: 3, type: "cider", temperature: "cold", size: "large", asset: "large_cold_cider.png" }, { index: 4, type: "cider", temperature: "hot", size: "small", asset: "small_hot_cider.png" }], solution_index: 4, explanation: "Options 1–3 follow the type–size rule; option 4 pairs cider with small (should be large)." },
        9: { id: "d9", difficulty: 9, title: "Three Attributes: Specific Combination #1", pattern: "three-attributes", constraints: { by_type: { coffee: { temperature: "hot", size: "small" }, tea: { temperature: "room", size: "medium" }, cider: { temperature: "cold", size: "large" } } }, options: [{ index: 1, type: "coffee", temperature: "hot", size: "small", asset: "small_hot_coffee.png" }, { index: 2, type: "tea", temperature: "room", size: "medium", asset: "medium_room_tea.png" }, { index: 3, type: "cider", temperature: "cold", size: "large", asset: "large_cold_cider.png" }, { index: 4, type: "coffee", temperature: "hot", size: "medium", asset: "medium_hot_coffee.png" }], solution_index: 4, explanation: "Options 1–3 follow the rule; option 4 is coffee but medium instead of small." },
        10: { id: "d10", difficulty: 10, title: "Three Attributes: Specific Combination #2", pattern: "three-attributes", constraints: { by_type: { coffee: { temperature: "room", size: "medium" }, tea: { temperature: "hot", size: "small" }, cider: { temperature: "cold", size: "large" } } }, options: [{ index: 1, type: "coffee", temperature: "room", size: "medium", asset: "medium_room_coffee.png" }, { index: 2, type: "tea", temperature: "hot", size: "small", asset: "small_hot_tea.png" }, { index: 3, type: "cider", temperature: "cold", size: "large", asset: "large_cold_cider.png" }, { index: 4, type: "tea", temperature: "cold", size: "small", asset: "small_cold_tea.png" }], solution_index: 4, explanation: "Options 1–3 conform to the rule; option 4 is tea but cold instead of hot." }
      };
      break;
    // Add more modules as they get implemented
    default:
      console.log(`⚠️ Unknown moduleId: ${moduleId}, falling back to Module 2`);
      instances = MODULE_2_INSTANCES; // Fallback to Module 2
  }
  
  if (!instances) {
    console.error(`❌ No instances found for moduleId: ${moduleId}`);
    return null;
  }
  
  console.log(`🔍 Available instances for Module ${moduleId}:`, Object.keys(instances));
  
  // Find instance closest to target difficulty
  const availableInstances = Object.keys(instances)
    .filter(key => !isNaN(key)) // Only numeric keys (exclude mealToButtonMapping)
    .map(Number)
    .sort((a, b) => a - b);
  
  console.log(`🔍 Numeric instance IDs:`, availableInstances);
  
  if (availableInstances.length === 0) {
    console.error(`❌ No numeric instances found for moduleId: ${moduleId}`);
    return null;
  }
  
  let closestInstanceId = null;
  
  try {
    closestInstanceId = availableInstances.reduce((closest, instanceId) => {
      console.log(`🔍 Processing instance ${instanceId}, current closest: ${closest}`);
      
      const currentInstance = instances[instanceId];
      console.log(`🔍 Current instance data:`, currentInstance);
      
      if (!currentInstance) {
        console.error(`❌ Instance ${instanceId} is null/undefined`);
        return closest;
      }
      
      if (typeof currentInstance.difficulty === 'undefined') {
        console.error(`❌ Instance ${instanceId} missing difficulty property:`, currentInstance);
        return closest;
      }
      
      // If this is the first instance or closest is null/undefined, use current
      if (closest === null || closest === undefined) {
        console.log(`🔍 First instance, using ${instanceId}`);
        return instanceId;
      }
      
      const closestInstance = instances[closest];
      console.log(`🔍 Closest instance data:`, closestInstance);
      
      if (!closestInstance) {
        console.error(`❌ Closest instance ${closest} is null/undefined`);
        return instanceId;
      }
      
      if (typeof closestInstance.difficulty === 'undefined') {
        console.error(`❌ Closest instance ${closest} missing difficulty property:`, closestInstance);
        return instanceId;
      }
      
      const currentDiff = Math.abs(currentInstance.difficulty - targetDifficulty);
      const closestDiff = Math.abs(closestInstance.difficulty - targetDifficulty);
      
      console.log(`🔍 Comparing difficulties: current=${currentInstance.difficulty} (diff=${currentDiff}), closest=${closestInstance.difficulty} (diff=${closestDiff})`);
      
      return currentDiff < closestDiff ? instanceId : closest;
    }, null);
  } catch (error) {
    console.error(`❌ Error in reduce function:`, error);
    console.log(`🔍 Available instances:`, availableInstances);
    console.log(`🔍 Instances object:`, instances);
    
    // Fallback: use first available instance
    closestInstanceId = availableInstances[0];
    console.log(`🔍 Using fallback instance: ${closestInstanceId}`);
  }
  
  if (closestInstanceId === null || closestInstanceId === undefined) {
    console.error(`❌ No valid instance ID found for moduleId: ${moduleId}, using fallback`);
    closestInstanceId = availableInstances[0]; // Use first available as last resort
  }
  
  const selectedInstance = instances[closestInstanceId];
  
  if (!selectedInstance) {
    console.error(`❌ Selected instance ${closestInstanceId} does not exist in instances object`);
    return null;
  }
  
  console.log(`✅ getModuleInstance: moduleId=${moduleId}, targetDifficulty=${targetDifficulty}, selected instance=${closestInstanceId} (difficulty=${selectedInstance?.difficulty})`);
  
  return {
    ...selectedInstance,
    instanceId: closestInstanceId
  };
};